module.exports = __webpack_public_path__ + "img/recruit2.4cde90ca.png";